import LocalizeNamespaces from 'shared/constants/localize-namespaces.mjs'
import { LocalizeValues } from 'shared/hooks/use-loco-translation'
import { BookingStatusEnum } from '../bookings/constants'
import { EventLocationTypeEnum } from '../events/constants'

export const calendarLoco: LocalizeValues[] = [
  LocalizeNamespaces.global,
  LocalizeNamespaces.list,
  LocalizeNamespaces.actions,
  LocalizeNamespaces.locale,
  LocalizeNamespaces.user,
  LocalizeNamespaces.validation,
  LocalizeNamespaces.name_of_times,
  LocalizeNamespaces.datepicker,
  LocalizeNamespaces.confirmation,
  LocalizeNamespaces.booking_calendar,
  LocalizeNamespaces.google_integration,
]

export const availabilityLoco: LocalizeValues[] = [
  LocalizeNamespaces.global,
  LocalizeNamespaces.name_of_times,
  LocalizeNamespaces.booking_calendar,
]

export const eventLocationLocoKeys: Record<EventLocationTypeEnum, string> = {
  [EventLocationTypeEnum.ExternalLink]: 'dashboard.calendar.event_location.online_meeting',
  [EventLocationTypeEnum.Zoom]: 'dashboard.calendar.event_location.online_meeting',
  [EventLocationTypeEnum.Personal]: 'dashboard.calendar.event_location.personal',
  [EventLocationTypeEnum.Phone]: 'dashboard.calendar.event_location.phone',
  [EventLocationTypeEnum.GoogleMeet]: 'dashboard.calendar.event_location.google_meet',
}

export const monthsLocoKeys = {
  january: 'global.month_list.january',
  february: 'global.month_list.february',
  march: 'global.month_list.march',
  april: 'global.month_list.april',
  may: 'global.month_list.may',
  june: 'global.month_list.june',
  july: 'global.month_list.july',
  august: 'global.month_list.august',
  september: 'global.month_list.september',
  october: 'global.month_list.october',
  november: 'global.month_list.november',
  december: 'global.month_list.december',
}

const bookingStatusLocoKeys = {
  [BookingStatusEnum.All]: 'global.all',
  [BookingStatusEnum.Cancelled]: 'global.cancelled',
  [BookingStatusEnum.Past]: 'dashboard.calendar.booking_status.past',
  [BookingStatusEnum.Scheduled]: 'dashboard.calendar.booking_status.scheduled',
  [BookingStatusEnum.Rescheduled]: 'dashboard.calendar.booking_status.rescheduled',
  [BookingStatusEnum.Upcoming]: 'dashboard.calendar.booking_status.upcoming',
}

export const getReadableBookingStatus = (status: BookingStatusEnum) => {
  return bookingStatusLocoKeys[status]
}

export const getReadableEventLocation = (location: EventLocationTypeEnum) => {
  return eventLocationLocoKeys[location]
}

export const getReadableMonthName = (date: Date) => {
  const month = date.toLocaleString('default', { month: 'long' })
  return monthsLocoKeys[month.toLowerCase() as keyof typeof monthsLocoKeys]
}
